import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Paper, useMediaQuery } from '@mui/material';
import Titlebar from '../TitleBar';
import { Pagination, SearchTable, TableBody3, TableBottom2, TableHeader } from '.';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../Utils/table';
import { userReturn,userReturnEntry,userReturnReg} from '../TitleList';

import { selectLocations, selectUserSaledata } from '../Selectors/Master/OutwardSelectors';
import { fetchUserReturnData } from '../../Store/PHPSlice/Return';
import ReactToPrint from 'react-to-print';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';
import styled, { inputStyles } from '../../Utils/inputChanges';
import Dropdown from '../FieldsComponents/Dropdown';
import axios from 'axios';
import { fetchLocationData } from '../../Store/PHPSlice/LocationApi';

const UserReturnReg = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const dispatch = useDispatch();
    const getItems = useSelector(selectUserSaledata);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);
    const componentRef = useRef();
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');
    const [activeMenu, setActiveMenu] = useState(userReturnEntry);
    const allschls = useSelector(selectLocations);

    const [formData, setFormData] = useState({
        fdt: '',
        tdt: '',
        zoneId: '',
        schlId: ''
    });
    const [userSchldata, setUserSchldata] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [selectRecords, setSelectRecords] = useState([]);
    useEffect(() => {

        if (userdata?.pageIds?.length > 0 && userdata?.role !== '1') {
            const pid = userdata?.pageIds?.find(item => item === 1);
            // if (pid === 1 && userdata?.role === '3') {
            //     setActiveMenu(onlyAdminSaleMenu);
            //     // console.log('hhi')
            // } else if (userdata?.role === '2') {
            //     setActiveMenu(UserSaleMenu);
            // } else {
            //     setActiveMenu(AdminSaleMenu);
            // }

            const selectpid = userdata?.pageIds?.filter(item => item === 1 || item === 3);
            // console.log(selectpid);
            if (selectpid?.length > 0) {
                const data = {
                    uid: userdata?.ID,
                    pageId: selectpid
                };
                fetchPageAssignSchools(data);
            }
        }
    }, []);

    useEffect(() => {
        if (userdata?.role === '1') {
            dispatch(fetchUserReturnData())
                .unwrap()
                .then((result) => {
                    // Handle success
                    // console.log('POST request successful!', result);
                    setSelectRecords(result);

                })
                .catch((error) => {
                    // Handle error
                    console.error('Error while making POST request:', error);
                    // You may want to display an error message to the user or perform any other action
                });
            dispatch(fetchLocationData());
        } else {
            const data = {
                userId: userdata?.ID
            };
            dispatch(fetchUserReturnData(data))
                .unwrap()
                .then((result) => {
                    // Handle success
                    // console.log('POST request successful!', result);
                    setSelectRecords(result);

                })
                .catch((error) => {
                    // Handle error
                    console.error('Error while making POST request:', error);
                    // You may want to display an error message to the user or perform any other action
                });
        }
    }, [dispatch]);

    if (!getItems) {
        return <h1>Loading...</h1>;
    }


    const fetchPageAssignSchools = async (id) => {
        const { uid, pageId } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getUserwisePageIdSchools&uid=${uid}&pageId=${pageId}`);
            setUserSchldata(response.data.data);
            // console.log(response.data)

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    // console.log(getItems);

    const compData = Array.isArray(selectRecords.data) ? selectRecords?.data.map((item, index) => (
        {
            srNo: item.ID,
            dt: item.DT,
            schl_stkId: item.schl_stkId,
            adsaleId: item.adsaleId,
            memo: item.memo,
            studNm: item.studNm,
            std: item.std,
            div: item.div,
            totqty: item.totqty,
            totamt: item.totamt,
            gst: item.gst,
            gst_val: item.gst_val,
            sts: item.sts,
            payableamt: item.payableamt,
            paymode: item.paymode,
            bnkNm: item.bnkNm,
            paidamt: item.paidamt,
            paymode: item.paymode,
            payableamt: item.payableamt,
            chqno: item.chqno,
            schlcd: item.schlcd,
            ph: item.ph,
            serialNumber: index + 1
        }
    )) : [];

    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const totalCount = compData.length;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);


    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.studNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.memo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.schlcd?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.ph?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.paymode?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totqty = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.totqty), 0);
    const totamt = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.totamt), 0);
    const totpaidamt = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.paidamt), 0);

    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),

    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };
    // console.log(displayedData);

    const fields = [
        { label: 'From Date', name: 'fdt', type: 'date' },
        { label: 'To Date', name: 'tdt', type: 'date' },
        // { label: 'Barcode', name: 'freight_ch' },
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };
    const dropdownOrdType = [
        {
            label: 'School',
            id: 'schlId',
            options: userdata?.role === '1' ? allschls?.data : userSchldata || [],
            value: formData.schlId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlId', value: newValue ? newValue.ID : '' } }, 'schlId'),
            getOptionLabel: (option) => option.schlcd || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true,
        }
    ];

    const handleSearch = (e) => {
        e.preventDefault();

        dispatch(fetchUserReturnData(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                // console.log('POST request successful!', result);
                setSelectRecords(result);

            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };
    return (
        <>
            {/* <Titlebar data={userdata?.role === '2' ? UserSaleMenu : AdminSaleMenu} /> */}
            <Titlebar data={activeMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>User Transfer Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>


                            <Grid container spacing={0.5}>
                                {fields.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleInputChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {
                                    dropdownOrdType?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                }

                                {/* {
                                    dropdownOrdType2?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                } */}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSearch}>Search</Button>
                                </Grid>
                            </Grid>

                            <div style={{ margin: '2% 5%' }}>
                                <ReactToPrint
                                    trigger={() => <Button variant="contained" color="primary">Print</Button>}
                                    content={() => componentRef.current}
                                />
                            </div>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />


                            <TableContainer style={{ marginTop: '2%', border: '1px solid #ccc' }} ref={componentRef}>
                                <Table>
                                    <TableHeader
                                        headCells={[
                                            { id: 'srNo', label: 'Sr.No' },
                                            { id: 'dt', label: 'Date' },
                                            { id: 'memo', label: 'TR Memo' },
                                            { id: 'studNm', label: 'User Name' },
                                            { id: 'ph', label: 'Contact' },
                                            // { id: 'std', label: 'Standard' },
                                            { id: 'schlcd', label: 'School' },
                                            { id: 'totqty', label: 'Total Qty' },
                                            { id: 'totamt', label: 'Total Amt' },
                                            { id: 'paidamt', label: 'Paid Amt' },
                                            { id: '', label: 'Bal Amt' },
                                            { id: 'paymode', label: 'Payment Mode' },
                                            { id: '', label: 'View', className: 'no-print' },      // 👈 Add className
                                            { id: 'edit', label: 'Edit', className: 'no-print' },   // 👈 Add className
                                            { id: 'delete', label: 'Delete', className: 'no-print' }, // 👈 Add className
                                            { id:'acceptsts',label:'Accept Sts'}
                                        ]}

                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData && displayedData.length > 0 ? (
                                            <>
                                                {displayedData?.map((row) => (
                                                    <TableBody3
                                                        key={row.srNo}
                                                        id={row.srNo}
                                                        dt={row.dt}
                                                        schl_stkId={row.schl_stkId}
                                                        adsaleId={row.adsaleId}
                                                        memo={row.memo}
                                                        studNm={row.studNm}
                                                        std={row.std}
                                                        div={row.div}
                                                        totqty={row.totqty}
                                                        totamt={row.totamt}
                                                        paidamt={row.paidamt}
                                                        gst={row.gst}
                                                        gst_val={row.gst_val}
                                                        sts={row.sts}
                                                        schlcd={row.schlcd}
                                                        paymode={row.paymode}
                                                        payableamt={row.payableamt}
                                                        ph={row.ph}
                                                        serialNumber={row.serialNumber}
                                                        selected={selected.indexOf(row.name) !== -1}
                                                        handleClick={(event) => handleClick(event, row.name)}
                                                    />
                                                ))}
                                                <TableBottom2
                                                    totpaidamt={totpaidamt}
                                                    totamt={totamt}
                                                    totqty={totqty}
                                                />
                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan={14} style={{ textAlign: "center", padding: "10px" }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>

                                </Table>
                            </TableContainer>

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />


                        </Paper>

                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default UserReturnReg;
